import { colors } from 'components/common'
import { createUseStyles } from 'react-jss'

const useProgressStyles = createUseStyles({
  progressWrapper: {
    position: 'relative',
    margin: '0.5rem 0',
    display: 'flex',
    width: '100%',
    height: 16,
    fontSize: 10,
    fontWeight: 'bold',
    padding: '0 0.5rem',
    justifyContent: 'flex-end',
    color: 'white',
    backgroundColor: colors.gray300,
    borderRadius: 20,
    overflow: 'hidden'
  },
  progressBar: {
    position: 'absolute',
    left: 0,
    width: 0,
    height: '100%',
    backgroundColor: customColor => customColor || colors.theme500,
    textAlign: 'right',
    borderRadius: 20,
    transition: 'width 0.3s ease-in-out'
  },
  progressValue: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 999
  }
})

export { useProgressStyles }
